import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Loader: React.FC = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    document.body.classList.add('loader-active');
    return () => {
      document.body.classList.remove('loader-active');
    };
  }, []);
    
  
  return (
    <div className="loader-overlay d-flex justify-content-center align-items-center">
      <div className="text-center">
        <img
          src="/images/spinner.gif"
          alt={t('Loading')}
          width={250}
          height={250}
        />
        <p className="text-white mt-3">{t('Loading')}</p>
      </div>
    </div>
  );
};

export default Loader;
